import React from "react";

import "./live-icon.m.css";

export default function LiveIcon({ storyHeader = false }) {
  return (
    <span styleName={`live-icon ${storyHeader ? "story-header-live-icon" : ""}`}>
      <span styleName="live-icon__dot" />
      <span styleName="live-icon__text">LIVE</span>
    </span>
  );
}
